import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL — permanently redirects to keyword-first slug.
export const Route = createFileRoute("/littleton-web-design")({
  beforeLoad: () => {
    throw redirect({
      to: "/web-design-littleton-colorado",
      statusCode: 301,
    });
  },
});
